import UsageReportSectionsList from './UsageReportSectionsList.component';

export default UsageReportSectionsList;
